import { RestClient } from '../lib/RestClient'

class DisciplinaService extends RestClient {
  constructor() {
    super('disciplina')
  }
}

export const Disciplina = new DisciplinaService()
